import React from 'react';
import { createPortal } from 'react-dom';
import { X, ClipboardList, CalendarClock, ArrowRight } from 'lucide-react';

const ORANGE = '#FF5E00';
const GOLD = '#C9A961';

const Option = ({ href, icon: Icon, title, desc, accent, testid, external }) => (
  <a
    href={href}
    {...(external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
    className="group block border-2 border-white/10 hover:border-[var(--acc)] bg-white/[0.02] p-5 transition-colors"
    style={{ '--acc': accent }}
    data-testid={testid}
  >
    <div className="flex items-start gap-4">
      <Icon className="w-6 h-6 shrink-0 mt-0.5" style={{ color: accent }} />
      <div className="flex-1">
        <div className="text-sm font-black tracking-[0.18em] uppercase text-white">{title}</div>
        <p className="text-xs text-gray-400 mt-1.5 leading-relaxed">{desc}</p>
      </div>
      <ArrowRight className="w-4 h-4 text-gray-500 group-hover:text-white group-hover:translate-x-1 transition-transform mt-1" />
    </div>
  </a>
);

export const ApplyChoiceModal = ({ open, onClose, applyHref }) => {
  if (!open) return null;
  return createPortal(
    <div className="fixed inset-0 z-[200] flex items-center justify-center px-4 bg-black/80 backdrop-blur-sm" onClick={onClose} data-testid="apply-choice-modal">
      <div className="w-full max-w-md border-2 p-6 relative" style={{ backgroundColor: '#050508', borderColor: `${GOLD}55` }} onClick={(e) => e.stopPropagation()}>
        <button onClick={onClose} className="absolute top-3 right-3 text-gray-500 hover:text-white p-1" aria-label="Close" data-testid="apply-choice-close"><X className="w-5 h-5" /></button>
        <div className="text-[10px] font-black tracking-[0.3em] uppercase mb-1" style={{ color: GOLD }}>Scholar Athlete Academy</div>
        <h2 className="text-2xl font-black text-white uppercase tracking-tight mb-5">How can we help?</h2>
        <div className="space-y-3">
          <Option href={applyHref} external={/^https?:\/\//i.test(applyHref)} icon={ClipboardList} accent={ORANGE} title="Apply Now" desc="Start a full application to enroll at the Academy." testid="apply-choice-apply" />
          <Option href="/preregister" icon={CalendarClock} accent={GOLD} title="Pre-Register 2027–28" desc="Hold your student's seat for next school year." testid="apply-choice-preregister" />
        </div>
      </div>
    </div>,
    document.body
  );
};
